// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-57ddb3ac]{width:100px;height:100px}.right-link[data-v-57ddb3ac]{padding:0 10px}", ""]);
// Exports
module.exports = exports;
